import React from "react";

import type { POI } from "@local-logic/client";

import * as styles from "./styles";

export function TransitRoutes({
  keyPrefix = "transit-routes",
  routes,
  useLongName = false,
  className = "",
}: {
  keyPrefix?: string;
  routes: POI["routes"];
  useLongName?: boolean;
  className?: string;
}) {
  if (!routes || routes.length === 0) {
    return null;
  }

  return (
    <div
      className={`${styles.container} ${className}`}
      data-testid="transit-routes-container"
    >
      <ul className={styles.list}>
        {routes.map((route, index) => (
          <li
            data-testid="transit-routes-item"
            key={`${keyPrefix}-${index}`}
            className={styles.item}
            style={
              {
                "--transit-route-color":
                  route.route_color && route.route_color !== "000000"
                    ? `#${route.route_color}`
                    : undefined,
                "--transit-route-text-color":
                  route.text_color && route.text_color !== "000000"
                    ? `#${route.text_color}`
                    : undefined,
              } as React.CSSProperties
            }
          >
            {useLongName ? route.long_name : route.short_name}
          </li>
        ))}
      </ul>
    </div>
  );
}
